import { c as _slicedToArray } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { useState } from 'react';
import { Modal, Card } from 'quanta-ui';

function TermsAndConditions(_ref) {
  var setShow = _ref.setShow,
      showterms = _ref.showterms;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2);
      _useState2[0];
      _useState2[1];

  var onModalClose = function onModalClose() {
    //setModalDisplay(false);
    setShow(false);
    document.body.classList.remove('overflow-y-hidden');
  };

  return /*#__PURE__*/React.createElement(Modal, {
    display: showterms,
    size: "medium",
    title: "Terms And Conditions",
    severity: "action",
    onClose: function onClose() {
      onModalClose();
    },
    modalCloseDisabled: false
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(Card, {
    className: "min-h-screen"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-justify"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-5 text-justify"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ml-11 ml-lg-0"
  }, "I/we give my/our consent to receive information in respect of policy servicing, claim servicing, updates on my policy, updates on new and existing product, marketing", /*#__PURE__*/React.createElement("br", null), " or servicing my relationship with Zurich Kotak General Insurance Company (India) Limited, its group companies/associates or agents through Telephone/Mobile/SMS/e-Mail, etc.", /*#__PURE__*/React.createElement("br", null), " Further, I/we understand that my/our consent to receive calls/communications shall be valid and shall prevail over my/our current or any subsequent registration of my/our", /*#__PURE__*/React.createElement("br", null), " number for the NDNC and shall continue to be treated as my/our consent/acceptance. (If you do not wish to accord your consent, please submit a Do Not Call (DNC) form along", /*#__PURE__*/React.createElement("br", null), " with this form.)"), /*#__PURE__*/React.createElement("div", {
    className: "mt-5 text-justify"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ml-11 ml-lg-0"
  }, "I/we have been explained to form, including the clause on consent to call, and I/we have signed the same after understanding and accepting the terms contained therein.")))), ' ')));
}

export default TermsAndConditions;
